module.exports = __webpack_public_path__ + "img/CM-MC-25-Volvo-Playful.9bd19a26.jpg";